import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import * as myGlobals from '../globals';
import 'rxjs/Rx';
import { ConfigService } from '../config.service';
declare var jQuery: any;
export class User {
    constructor() { }
}

@Injectable()
export class LoginService {
    private _loginUrl = myGlobals.apiurl + 'customer/signIn';
    private _checkmail = myGlobals.apiurl + 'customer/emailValidation';
    private _checkphone = myGlobals.apiurl + 'customer/phoneValidation';
    private _signotp = myGlobals.apiurl + 'customer/verifyVerificationCode';
    private _verifyotp = myGlobals.apiurl + 'customer/verifyPhoneNumber';
    private _otpresend = myGlobals.apiurl + 'customer/resendOtp';
    private _signup = myGlobals.apiurl + 'customer/signUp';
    private _referralcode = myGlobals.apiurl + 'customer/referralCodeValidation';
    private _forgotpassword = myGlobals.apiurl + 'customer/forgotPassword';
    private _updatepassword = myGlobals.apiurl + 'customer/password';

    constructor(
        private _router: Router,
        private _http: Http,
        private _cookie: ConfigService) { }

    login(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._loginUrl, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                if (res) {
                    this._cookie.setItem(res.data);
                }
                return res;
            })
    }
    verifymail(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._checkmail, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    verifyphone(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._checkphone, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    signupotp(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._signotp, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    signupotpresend(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._otpresend, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    verifyotp(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._verifyotp, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    signupcall(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._signup, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    promocode(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._referralcode, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    forgotPass(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._forgotpassword, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
    updatePass(user: any) {
        let body = JSON.stringify(user);
        return this._http.patch(this._updatepassword, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                jQuery('#loader').hide();
                return res;
            })
    }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/login/login.service.ts